import { render, staticRenderFns } from "./addBar.vue?vue&type=template&id=3e3c65f6&scoped=true&"
import script from "./addBar.vue?vue&type=script&lang=js&"
export * from "./addBar.vue?vue&type=script&lang=js&"
import style0 from "./addBar.vue?vue&type=style&index=0&id=3e3c65f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3c65f6",
  null
  
)

export default component.exports